import { all, call, put, takeEvery } from 'redux-saga/effects';
import actions from '../actions';
import CategoryHttpService from '../../services/category.http';

export function* GET({ payload }) {
  yield put({
    type: actions.category.SET_STATE,
    payload: {
      selected_category: null,
      loading: true
    }
  });

  const response = yield call(CategoryHttpService.get, payload);
  if (response) {
    if (response.state < 400) {
      yield put({
        type: actions.category.SET_STATE,
        payload: {
          selected_category: response.data
        }
      });
    } else {
      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'error',
          message: response.data.message
        }
      });
    }
  }

  yield put({
    type: actions.category.SET_STATE,
    payload: { loading: false }
  });
}

export function* LIST_OF_EVENT({ payload }) {
  yield put({
    type: actions.category.SET_STATE,
    payload: {
      categories: [],
      loading: true
    }
  });

  const response = yield call(CategoryHttpService.listOfEvent, payload);
  if (response) {
    if (response.status < 400) {
      yield put({
        type: actions.category.SET_STATE,
        payload: {
          categories: [...response.data]
        }
      });
    } else {
      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'error',
          message: response.data.message
        }
      });
    }
  }

  yield put({
    type: actions.category.SET_STATE,
    payload: { loading: false }
  });
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.category.GET, GET),
    takeEvery(actions.category.LIST_OF_EVENT, LIST_OF_EVENT)
  ]);
}
